// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3z8B9","footer":"styles_footer__3NyIf","passCodeTooltip":"styles_passCodeTooltip__BVMPX"};